var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.469777 6.53033C0.176884 6.23744 0.176884 5.76256 0.469777 5.46967L5.24275 0.696699C5.53564 0.403806 6.01051 0.403806 6.30341 0.696699C6.5963 0.989593 6.5963 1.46447 6.30341 1.75736L2.06077 6L6.30341 10.2426C6.5963 10.5355 6.5963 11.0104 6.30341 11.3033C6.01051 11.5962 5.53564 11.5962 5.24275 11.3033L0.469777 6.53033ZM15.2212 6.75H1.00011V5.25H15.2212V6.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeftIcon);
export default __webpack_public_path__ + "static/media/arrow_left_icon.216a2d6e75e62ad9618f5a68223f19eb.svg";
export { ForwardRef as ReactComponent };